import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import LoginPage from "./pages/auth/LoginPage";
import Layout from "./components/layout/Layout";
import { ProtectedRoute } from "./utils/ProtectedRoute";
import Home from "./pages/otherPages/Home";
import Register from "./pages/auth/Register";
import axios from "axios";
import Inquiry from "./pages/otherPages/Inquiry";
import AddUpdate from "./pages/otherPages/AddUpdate";




axios.defaults.baseURL = "https://api.intellitech.ae/api/v1";
//axios.defaults.baseURL = "http://localhost:6035/api/v1";
axios.defaults.withCredentials = true;

const App = () => {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<LoginPage />} />
        <Route path="/register" element={<Register />} />
        <Route path="*" element={<LoginPage />} />
        <Route
          element={
            <ProtectedRoute>
              <Layout />
            </ProtectedRoute>
          }
        >
          <Route path="/dashboard" element={<Home />} />
          <Route path="/inquiry" element={<Inquiry />} />
          <Route path="/add-update" element={<AddUpdate />} />>
        </Route>
      </Routes>
    </BrowserRouter>
  );
};

export default App;
